var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'src/system/query/axiosQuery';
// Refetch when the page arg changes
function forceRefetch(_a) {
    var currentArg = _a.currentArg, previousArg = _a.previousArg;
    return (currentArg === null || currentArg === void 0 ? void 0 : currentArg.page) !== (previousArg === null || previousArg === void 0 ? void 0 : previousArg.page);
}
function serializeQueryArgs(_a) {
    var endpointName = _a.endpointName;
    return endpointName;
}
// TODO Reset state on logout
export var communityChatsApi = createApi({
    reducerPath: 'communityChatsApi',
    baseQuery: axiosBaseQuery({ baseUrl: '/community/dialogs' }),
    refetchOnReconnect: true,
    tagTypes: ['Chat'],
    endpoints: function (builder) { return ({
        getAllChats: builder.query({
            query: function (_a) {
                var page = _a.page, universityId = _a.universityId;
                if (universityId === 0) {
                    throw new Error('universityId is required');
                }
                return {
                    url: '/',
                    method: 'GET',
                    params: { universityId: universityId, limit: 20, offset: page * 20 },
                    // params: { limit: 20, offset: page * 20 },
                };
            },
            providesTags: [{ type: 'Chat', id: 'LIST' }],
            serializeQueryArgs: serializeQueryArgs,
            merge: function (oldData, newData) {
                if (!oldData)
                    return newData;
                return {
                    dialogs: __spreadArray(__spreadArray([], oldData.dialogs, true), newData.dialogs, true),
                    total: newData.total,
                };
            },
            forceRefetch: forceRefetch,
        }),
        getChat: builder.query({
            query: function (_a) {
                var id = _a.id, universityId = _a.universityId;
                if (universityId === 0 || id === 0) {
                    throw new Error('universityId or id is required');
                }
                return {
                    url: "/".concat(id),
                    method: 'GET',
                    params: { universityId: universityId },
                };
            },
            transformResponse: function (response) {
                return response.dialog;
            },
            providesTags: function (_, __, _a) {
                var id = _a.id;
                return [{ type: 'Chat', id: id }];
            },
        }),
        getMyChats: builder.query({
            query: function (_a) {
                var page = _a.page, universityId = _a.universityId;
                if (universityId === 0) {
                    throw new Error('universityId is required');
                }
                return {
                    url: '/my',
                    method: 'GET',
                    params: { universityId: universityId, limit: 20, offset: page * 20 },
                };
            },
            providesTags: [{ type: 'Chat', id: 'MY_CHATS' }],
            serializeQueryArgs: serializeQueryArgs,
            merge: function (oldData, newData) {
                if (!oldData)
                    return newData;
                return {
                    dialogs: __spreadArray(__spreadArray([], oldData.dialogs, true), newData.dialogs, true),
                    total: newData.total,
                };
            },
            forceRefetch: forceRefetch,
        }),
        joinToChat: builder.mutation({
            query: function (_a) {
                var chat = _a.chat, universityId = _a.universityId;
                if (universityId === 0 || chat.id === 0) {
                    throw new Error('universityId or chatId is required');
                }
                return {
                    url: "/".concat(chat.id, "/join"),
                    method: 'POST',
                    data: { universityId: universityId },
                };
            },
            invalidatesTags: [{ type: 'Chat', id: 'LIST' }],
            onQueryStarted: function (_a, _b) {
                var chat = _a.chat, universityId = _a.universityId;
                var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                var getChat = dispatch(communityChatsApi.util.updateQueryData('getChat', { id: chat.id, universityId: universityId }, function (draft) {
                    draft.isMember = true;
                    draft.membersCount += 1;
                }));
                var getMyChats = dispatch(communityChatsApi.util.updateQueryData('getMyChats', { universityId: universityId, page: 0 }, function (draft) {
                    var _a;
                    var index = draft.dialogs.findIndex(function (d) { return d.id === chat.id; });
                    if (index === -1) {
                        draft.dialogs.unshift({
                            id: chat.id,
                            description: chat.description,
                            name: chat.name,
                            lastMessage: ((_a = chat.lastMessage) === null || _a === void 0 ? void 0 : _a.content) || null,
                            unreadCount: 0,
                            avatar: chat.avatar,
                        });
                    }
                }));
                queryFulfilled.catch(function () {
                    getChat.undo();
                    getMyChats.undo();
                });
            },
        }),
        leaveFromChat: builder.mutation({
            query: function (_a) {
                var chatId = _a.chatId, universityId = _a.universityId;
                if (universityId === 0 || chatId === 0) {
                    throw new Error('universityId or chatId is required');
                }
                return {
                    url: "/".concat(chatId, "/leave"),
                    method: 'DELETE',
                    params: { universityId: universityId },
                };
            },
            invalidatesTags: function (_, __, _a) {
                var chatId = _a.chatId;
                return [
                    { type: 'Chat', id: 'LIST' },
                    { type: 'Chat', id: chatId },
                ];
            },
            onQueryStarted: function (arg, _a) {
                var dispatch = _a.dispatch, queryFulfilled = _a.queryFulfilled;
                queryFulfilled.then(function () {
                    dispatch(communityChatsApi.util.updateQueryData('getMyChats', { universityId: arg.universityId, page: 0 }, function (draft) {
                        var index = draft.dialogs.findIndex(function (d) { return d.id === arg.chatId; });
                        if (index !== -1) {
                            draft.dialogs.splice(index, 1);
                        }
                    }));
                });
            },
        }),
    }); },
});
export var useGetAllChatsQuery = communityChatsApi.useGetAllChatsQuery, useGetMyChatsQuery = communityChatsApi.useGetMyChatsQuery, useGetChatQuery = communityChatsApi.useGetChatQuery, useJoinToChatMutation = communityChatsApi.useJoinToChatMutation, useLeaveFromChatMutation = communityChatsApi.useLeaveFromChatMutation;
